import {
  SET_REPORT_VALUE
} from '../constants/reportView';

const initialState = {
  reportData: {},
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case SET_REPORT_VALUE:
      return {
        ...state,
        reportData: payload,
      };
    default:
      return state;
  }
}